require([
	'jquery'
], function(
	$
	) {

	'use strict';


	var audience = $('html').attr('data-audience');

	if (!audience){
		$('.section-cards').first().attr('data-audience');
	}

	$('.section-grid-selection[data-audience=' + audience + ']').addClass('is_active');
	// console.log('.section-grid-selection[data-audience=' + audience + ']');

	$('.js_change-audience[data-audience=' + audience + ']').addClass('is_active');
	// console.log('.js_change-audience[data-audience=' + audience + ']');


});
define("root/Assets/Templates/Html/GridSelection/Js/GridSelection", function(){});

